import React, { useState } from "react";
import { Helmet } from "react-helmet";
import PageHeader from "../../../../components/PagesComponents/UniversalComponents/PageHeader.component";
import "../../../../styles/Pages/Financial/CashOutFlow/Charity/Charity.style.css";

import ScolarshipAndFeeWaiver from "./ScolarshipAndFeeWave";
import EducationalMaterial from "./EducationalMaterial";
import CommunityOutreach from "./CommunityOutreach";
import ReliefAndWelfare from "./ReliefAndWelfare";
import OtherCharity from "./OtherCharity";
import SupportToLowGrade from "./SupportToLowGrade";

const Body = () => {
  const [selectedOption, setSelectedOption] = useState("");

  const options = [
    { label: "Scholarships & fee waivers", value: "scholarships" },
    { label: "Educational material donation", value: "education" },
    { label: "Community outreach", value: "community" },
    { label: "Support to low grade", value: "support" },
    { label: "Relief & welfare", value: "relief" },
    { label: "Others charity", value: "others" },
  ];

  const renderComponent = () => {
    switch (selectedOption) {
      case "scholarships":
        return <ScolarshipAndFeeWaiver />;
      case "education":
        return <EducationalMaterial />;
      case "community":
        return <CommunityOutreach />;
      case "relief":
        return <ReliefAndWelfare />;
      case "others":
        return <OtherCharity />;
      case "support":
        return <SupportToLowGrade />;
      default:
        return <div></div>;
    }
  };

  return (
    <section className="cahsOutFlowCharity">
      <Helmet>
        <title>Charity</title>
        <meta
          name="description"
          content="Monitor and analyze cash inflow trends and contributions."
        />
        <meta
          name="keywords"
          content="cash outflow, financial dashboard, cash flow analysis, business finance"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>

      <PageHeader title={"Charity"} />

      <div className="cashOutFlowMainContainer">
        <div className="menuSection">
          <h3>Choose any section that you want to visit</h3>
          <div className="seperater-line"></div>
          <div className="buttons-container">
            {options.map((option, index) => (
              <button
                key={index}
                className={`blueActionBtnLight toggleActionBtn ${
                  selectedOption === option.value ? "active" : ""
                }`}
                onClick={() => setSelectedOption(option.value)}
              >
                <input
                  type="radio"
                  name="charityOption"
                  value={option.value}
                  checked={selectedOption === option.value}
                  onChange={() => setSelectedOption(option.value)}
                />
                <span className="box">{option.label}</span>
              </button>
            ))}
          </div>
        </div>

        <div className="main-panel">{renderComponent()}</div>
      </div>
    </section>
  );
};

export default Body;
